import styled from "styled-components";
import {Section} from "@acc-monorepo/gatsby-stories/v2/styles/shared";

export const ImageRowSection = styled(Section)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding: 2rem 0;
  gap: 2px;
  
  .gatsby-image-wrapper {
    display: block;
    flex: 1 1 33%;
    height: 24vh;
    background-color: #b8d1ea;
  }
  
  @media(min-width: 768px) {
    padding: 2rem 0;
    
    .gatsby-image-wrapper {
      height: 20rem;
    }
  }

  @media(min-width: 1200px) {
    padding: 2rem 0;
    gap: 4px;

    .gatsby-image-wrapper {
      height: 26rem;
    }
  }
`

export default ImageRowSection
